import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  NgZone,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  HostListener,
  OnDestroy,
} from "@angular/core";
import { FormGroup, FormControl, FormBuilder, FormArray } from "@angular/forms";

import { OnboardEmployeePersonalDetails } from "../../shared/models/OnboardEmployeePersonalDetails";
import { OnboardEmergencyContactDetails } from "../../shared/models/OnboardEmergencyContactDetails";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ComponentIdentificationService } from "../../shared/service/component-identification.service";
import { hrEmpPersonalDetails } from "../../shared/models/hrEmpPersonalDetails";
import { EmployeeService } from "../../shared/service/employee.service";
import { isNullOrUndefined, isUndefined } from "util";
import { OnboardEmpFamilyDetail } from "../../shared/models/OnboardEmpFamilyDetail";
import { isEmpty } from "rxjs/Operators";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import * as _moment from "moment";
import { DatePipe } from "@angular/common";
import { HrEmpFamilyDetail, LeaveTypeDetails } from "../../shared/models/hrEmpFamilyDetail";
import { ToastrService } from "ngx-toastr";
import { UserService } from "../../shared/service/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { DepartmentsService } from "../../shared/service/departments.service";
const moment = _moment;
export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-personal-details",
  templateUrl: "./personal-details.component.html",
  styleUrls: ["./personal-details.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,

  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class PersonalDetailsComponent implements OnInit, OnChanges, OnDestroy {
  error: string;
  newAttribute: any = {};
  PersonalDetform: FormGroup;
  Age: number;
  personalDetails: any;
  originalPersonalDetails: any;
  MaritalStatus: any;
  @Input() EmpId: any;
  @Input() empCode: any;
  @Output("personalDetValue") personalDetValue = new EventEmitter();
  @Output("chilrenArray") chilrenArray = new EventEmitter();
  result: any;
  LoginEmpCode: any;
  permission: any;
  editEnable: boolean = true;
  Children: FormArray = this.fb.array([]);
  parentComponentName: string;
  emergencyContactDtlsDisable: boolean = false;
  parentalDtlsDisable: boolean = false;
  IsExpand = true;
  todayDate: Date;
  approveCheckMyProfile: any;
  disableforMyProfile: boolean;
  relationList: any;
  isProfile: boolean;
  disableIfFatherDOB: boolean;
  disableIfMotherDOB: boolean;
  enableSpouseRequired: boolean;
  enableChildRequired: boolean;
  motherDetReq: boolean = true;
  fatherDetReq: boolean = true;
  spouseDetReq: boolean = true;
  gettingBasicDet: BasicEmployeeDetails;
  enableReqforFTELoc: boolean = true;
  originalChildren: any;
  isLoader: boolean = false;
  disableIfChildDOB: boolean[] = [];
  datearray = [];
  days = [];
  eeTypeList: any;
  teamList: any;
  @Input() isDetRequired: boolean = false;
  locationsList: any;
  IsRequired = false;
  showMaternityPaternity = false;
  leaveTypeList: LeaveTypeDetails[];
  destroyed = false;

  constructor(
    private route: ActivatedRoute,
    private emp_Svc: EmployeeService,
    public dialog: MatDialog,
    private _service: OnboardingService,
    private userService: UserService,
    private toastr: ToastrService,
    private changeCom_svc: ComponentIdentificationService,
    private emp_svc: EmployeeService,
    private fb: FormBuilder,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private deptSvc: DepartmentsService
  ) { }

  ngOnInit() {
    // this.isLoader = true;
    this.LoginEmpCode = this.userService.getEmpCode();
    this.route.params.subscribe((params) => {
      this.empCode = params["empCode"];
      this.initializeParamChange();
    });
    //this.getSubmitMyProfileData();
    setTimeout(() => {
      this.isLoader = false;
    }, 1500);
  }
  initializeParamChange() {
    //get the login employee code
    this.LoginEmpCode = this.userService.getEmpCode().toString();
    //this.EmpId = this.LoginEmpCode;

    if (!isNullOrUndefined(this.empCode)) {
      if (this.router.url.startsWith("/myprofile/")) {
        this.showMaternityPaternity = false;
        if (this.empCode === this.LoginEmpCode) this.isProfile = true;
        else this.router.navigate(["/EmployeeWithoutPermission"]);
      }
    }
  }

  ngOnChanges() {
    this.getEeType();
    this.getTeams();
    this.todayDate = new Date();
    this.changeCom_svc.componentName.subscribe(
      (response) => (this.parentComponentName = response)
    );
    if (this.parentComponentName == "app-onboarding") {
      this.IsExpand = false;
    }
    if (this.parentComponentName == "app-hr-employee-details") {
      this.personalDetails = new hrEmpPersonalDetails();
      this.leaveTypeList = [];
      this.showMaternityPaternity = true;
      this.personalDetails.emergencyContactDtls = [];
      this.personalDetails.parentalLeaves = [];
      if (!isUndefined(this.empCode)) {
        //this.getLeaveTypes();
        this.GetEmployeePersonalDetailsbyHR();
        this.getRelations();
        this.getBasicEmployeeByCode();
      } else {
        this.addFieldValue();
      }
    } else {
      this.personalDetails = new OnboardEmployeePersonalDetails();
      this.getRelations();
      this.GetEmployeePersonalDetails();
      this.IsRequired = true;
    }
    this.FormInitialization();
  }
  getRelations() {
    this._service.getRelation().subscribe((data: any) => {
      this.relationList = data;
    });
  }

  getLeaveTypes() {
    this.emp_svc.getLeaveType().subscribe((data: any) => {
      this.leaveTypeList = data;
    });
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  FormInitialization() {
    this.PersonalDetform = new FormGroup({
      NoOfDependents: new FormControl(),
      FatherName: new FormControl(),
      FatherDOB: new FormControl(),
      FatherAge: new FormControl(""),
      FatherDeceased: new FormControl(),
      MotherName: new FormControl(),
      MotherDOB: new FormControl(),
      MotherAge: new FormControl(""),
      MotherDeceased: new FormControl(),
      MaritalStatus: new FormControl(),
      WeddingDate: new FormControl(),
      SpouseName: new FormControl(),
      SpouseCelebratedDOB: new FormControl(),
      SpouseAge: new FormControl(""),
      SpouseDeceased: new FormControl(),
      kidDOB: new FormControl(),
      Children: this.Children,
    });
  }
  createChildren(item = null) {
    if (item != null) {
      var row = this.fb.group({
        ID: item.ID,
        EmpID: item.EmpID,
        Name: item.Name,
        RelationId: item.RelationId,
        DOB: item.DOB,
        Age: item.Age,
        Deceased: item.Deceased,
      });
    } else {
      var row = this.fb.group({
        ID: [""],
        EmpId: [""],
        Name: [""],
        RelationId: [""],
        DOB: [""],
        Age: [""],
        Deceased: [""],
      });
    }
    this.Children.push(row);
  }
  checkMotherDetailReq(event: any) {
    if (event.checked == true) {
      this.motherDetReq = false;
    } else {
      this.motherDetReq = true;
    }
  }
  checkFatherDetailReq(event: any) {
    if (event.checked == true) {
      this.fatherDetReq = false;
    } else {
      this.fatherDetReq = true;
    }
  }
  checkSpouseDetailReq(event: any) {
    if (event.checked == true) {
      this.spouseDetReq = false;
    } else {
      this.spouseDetReq = true;
    }
  }

  getTeams() {
    this.deptSvc.getMasterGroupByCategory("Team").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.teamList = dataList;
          this.teamList = this.teamList.filter(
            (team) => team.Value != "Onshore"
          );
        });
    });
  }

  getEmployeeTypeValue(Id) {
    if (this.eeTypeList != null) {
      for (var i = 0; i < this.eeTypeList.length; i++) {
        if (this.eeTypeList[i].ID == Id) return this.eeTypeList[i].Value;
      }
    }
  }

  getEeType() {
    this.deptSvc.getMasterGroupByCategory("EeType").subscribe((data: any) => {
      this.deptSvc
        .getMasterGroupByGroupID(data[0].ID)
        .subscribe((dataList: any) => {
          this.eeTypeList = dataList;
        });
    });
  }

  getTeamValue(Id) {
    if (this.teamList != null) {
      for (var i = 0; i < this.teamList.length; i++) {
        if (this.teamList[i].ID == Id) return this.teamList[i].Value;
      }
    }
  }

  setToDate(fromDateofJoining: Date, index) {
    if (fromDateofJoining != null) {
      var date = new Date(fromDateofJoining);
      const fromYear = date.getFullYear();
      const fromMonth = date.getMonth();
      const fromDate = date.getDate();
      this.datearray[index] = new Date(fromYear, fromMonth, fromDate);
      if (!this.destroyed) this.cdr.detectChanges();
    }
  }

  duplicateDates(index) {
    var leaves = this.personalDetails.parentalLeaves;
    var hasError = false;
    if (index != null) {
      if (this.personalDetails.parentalLeaves[index].FromDate != null && leaves.find((leave, indx) => leave.FromDate != null && new Date(leave.FromDate) == new Date(this.personalDetails.parentalLeaves[index].FromDate) && index != indx)) {
        this.toastr.warning("Select valid date")
        hasError = true;
        this.personalDetails.parentalLeaves[index].FromDate = null;
        return;
      }
      if (!hasError && this.personalDetails.parentalLeaves[index].ToDate != null && leaves.find((leave, indx) => new Date(leave.ToDate) == new Date(this.personalDetails.parentalLeaves[index].ToDate) && index != indx)) {
        this.toastr.warning("Select valid date")
        this.personalDetails.parentalLeaves[index].ToDate = null;
        return
      }
      if (!hasError && this.personalDetails.parentalLeaves[index].FromDate != null && this.personalDetails.parentalLeaves[index].ToDate != null) {
        leaves.filter((leave, indx) => {
          if (!hasError && new Date(this.personalDetails.parentalLeaves[index].FromDate) > new Date(leave.FromDate) && new Date(this.personalDetails.parentalLeaves[index].FromDate) < new Date(leave.ToDate) && index != indx) {
            this.toastr.warning("Select valid date")
            hasError = true;
            this.personalDetails.parentalLeaves[index].FromDate = null;
            this.personalDetails.parentalLeaves[index].ToDate = null;
            return
          }
          if (!hasError && new Date(this.personalDetails.parentalLeaves[index].FromDate) < new Date(leave.FromDate) && new Date(this.personalDetails.parentalLeaves[index].ToDate) > new Date(leave.FromDate) && index != indx) {
            this.toastr.warning("Select valid date")
            hasError = true;
            this.personalDetails.parentalLeaves[index].FromDate = null;
            this.personalDetails.parentalLeaves[index].ToDate = null;
            return
          }
        })
      }

    }
  }

  calculateDates(index) {
    if (
      this.personalDetails.parentalLeaves[index].FromDate != null &&
      this.personalDetails.parentalLeaves[index].ToDate != null &&
      this.personalDetails.parentalLeaves[index].LeaveTypeId == 3
    ) {
      var fromDate = new Date(this.personalDetails.parentalLeaves[index].FromDate);
      var toDate = new Date(this.personalDetails.parentalLeaves[index].ToDate);

      let daysDiff = 0;

      // Loop through each day between fromDate and toDate
      for (let date = new Date(fromDate); date <= toDate; date.setDate(date.getDate() + 1)) {
        // Check if the day is not Saturday (6) or Sunday (0)
        if (date.getDay() !== 0 && date.getDay() !== 6) {
          daysDiff++;
        }
      }

      this.days[index] = daysDiff;
    } else if (
      this.personalDetails.parentalLeaves[index].FromDate != null &&
      this.personalDetails.parentalLeaves[index].ToDate != null
    ) {
      var fromDate = new Date(this.personalDetails.parentalLeaves[index].FromDate);
      var toDate = new Date(this.personalDetails.parentalLeaves[index].ToDate);
      const timeDiff = toDate.getTime() - fromDate.getTime();

      const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)) + 1;

      this.days[index] = daysDiff;
    }
    else {
      this.days[index] = null;
    }

  }

  getBasicEmployeeByCode() {
    if (this.empCode != null) {
      this.emp_Svc.getBasicEmployeeById(this.empCode).subscribe((data: any) => {
        this.gettingBasicDet = data;
        if (this.gettingBasicDet.ConsultantType == "SubCon") {
          this.enableReqforFTELoc = false;
        } else {
          if (
            this.gettingBasicDet.LocationID != 1 &&
            this.gettingBasicDet.LocationID != 2
          ) {
            this.enableReqforFTELoc = false;
          } else {
            this.enableReqforFTELoc = true;
          }
        }
        if (!this.destroyed) this.cdr.detectChanges();
      });
    }
    return this.gettingBasicDet;
  }

  detectChanges() {
    this.cdr.detectChanges();
  }

  getRefreshPage() {
    window.location.reload();
  }

  getSubmitMyProfileData() {
    this.emp_svc
      .GetProfileVerificationStatus(this.LoginEmpCode)
      .subscribe((data: any) => {
        this.approveCheckMyProfile = data;
        if (this.isProfile == true) {
          for (var i = 0; i < data.length; i++) {
            this.disableforMyProfile = data[i].Submitted;
          }
        }
        if (this.disableforMyProfile == true) {
          this.PersonalDetform.disable();
          this.Children.disable();
        }
      });
  }

  addFieldValue() {
    this.personalDetails.emergencyContactDtls.push(this.newAttribute);
    this.newAttribute = {};
  }

  addParentalFieldValue() {
    if (this.personalDetails.parentalLeaves != null) {
      this.personalDetails.parentalLeaves.push(this.newAttribute);
      this.newAttribute = {};
    }
  }

  deleteFieldValue(index, n) {
    if (n == 1) {
      if (this.personalDetails.emergencyContactDtls.length == 1) {
        this.toastr.warning(
          "Minimum one Emergency Contact Details is required"
        );
        return;
      }
    }
    if (n == 0) {
      this.confirmDialog(this.Children.value, index, "DeleteChildren");
    } else if (n == 1) {
      this.confirmDialog(this.personalDetails.emergencyContactDtls, index, "");
    } else if (n == 2) {
      this.confirmDialog(this.personalDetails.parentalLeaves, index, "");
    }
  }

  //onEditCloseItems() { this.isEditItems = !this.isEditItems; }
  confirmDialog(array, index, string) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(
      "Confirm Action",
      message,
      deleteType
    );
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          if (string == "DeleteChildren") {
            this.Children.value.splice(index, 1);
            var arr = this.Children.value;
            this.Children.clear();
            for (var i = 0; i < arr.length; i++) {
              this.createChildren(arr[i]);
            }
            this.personalDetails.NoOfDependents -= 1;
          } else {
            array.splice(index, 1);
            this.days.splice(index, 1);
          }
          if (!this.destroyed) this.cdr.detectChanges();
        }
      },
      (error) => {
        this.result = error;
      }
    );
    //return this.result;
  }
  enableRequiredForSpouseDet(event: any) {
    if (event.value == 1) {
      this.enableSpouseRequired = true;
    } else {
      this.enableSpouseRequired = false;
      this.personalDetails.WeddingDate = null;
      this.personalDetails.Spouse.Name = null;
      this.personalDetails.Spouse.DOB = null;
    }
  }

  getObjectState() {
    const originalEmp = this.originalPersonalDetails;
    const currentEmp = this.personalDetails;
    const originalChild = this.originalChildren;
    const currentChild = this.Children.value;
    var personalVal =
      JSON.stringify(originalEmp) === JSON.stringify(currentEmp);
    var childrenVal =
      JSON.stringify(originalChild) === JSON.stringify(currentChild);
    return !(personalVal && childrenVal);
  }

  GetEmployeePersonalDetails() {
    this._service.GetEmployeePersonalDetails(this.EmpId).subscribe(
      (data: any) => {
        this.personalDetails.emergencyContactDtls = [];
        this.personalDetails.parentalLeaves = [];
        if (data != null) {
          this.personalDetails = data;
          this.originalPersonalDetails = JSON.parse(
            JSON.stringify(this.personalDetails)
          );
          this.personalDetails.Father = new OnboardEmpFamilyDetail();
          this.personalDetails.Mother = new OnboardEmpFamilyDetail();
          this.personalDetails.Spouse = new OnboardEmpFamilyDetail();
          this.personalDetails.children = this.Children.value;
          if (
            this.personalDetails.FamilyDetails != null &&
            this.personalDetails.FamilyDetails.count != 0
          ) {
            this.personalDetails.FamilyDetails.forEach((item) => {
              if (item.RelationId == 1) this.personalDetails.Father = item;
              else if (item.RelationId == 2) this.personalDetails.Mother = item;
              else if (item.RelationId == 3) this.personalDetails.Spouse = item;
              else this.createChildren(item);
            });
          }
          if (this.personalDetails.MaritalStatus == 1) {
            this.enableSpouseRequired = true;
          } else {
            this.enableSpouseRequired = false;
          }
          if (
            this.personalDetails.emergencyContactDtls == null ||
            this.personalDetails.emergencyContactDtls.length == 0
          ) {
            this.addFieldValue();
          }
          if (
            this.personalDetails.parentalLeaves == null ||
            this.personalDetails.parentalLeaves.length == 0
          ) {
            this.addParentalFieldValue();
          }
        } else {
          this.addFieldValue();
          this.addParentalFieldValue();
        }
        this.originalPersonalDetails = JSON.parse(
          JSON.stringify(this.personalDetails)
        );
        this.originalChildren = JSON.parse(JSON.stringify(this.Children.value));
        this.EmitOutputValue();
      },
      (error) => (this.error = error)
    );
  }
  valueChange(value) {
    this.MaritalStatus = value;
  }
  GetEmployeePersonalDetailsbyHR() {
    if (this.empCode != null) {
      this.emp_svc.getEmployeePersonalDetails(this.empCode).subscribe(
        (data: any) => {
          this.personalDetails.emergencyContactDtls = [];
          this.personalDetails.parentalLeaves = [];
          if (data != null) {
            this.personalDetails = data;
            this.personalDetails.Father = new HrEmpFamilyDetail();
            this.personalDetails.Mother = new HrEmpFamilyDetail();
            this.personalDetails.Spouse = new HrEmpFamilyDetail();
            this.personalDetails.children = this.Children.value;
            if (
              this.personalDetails.FamilyDetails != null &&
              this.personalDetails.FamilyDetails.count != 0
            ) {
              this.personalDetails.FamilyDetails.forEach((item) => {
                if (item.RelationId == 1) this.personalDetails.Father = item;
                else if (item.RelationId == 2)
                  this.personalDetails.Mother = item;
                else if (item.RelationId == 3)
                  this.personalDetails.Spouse = item;
                else {
                  this.createChildren(item);
                }
              });
            }
            if (
              this.personalDetails.emergencyContactDtls == null ||
              this.personalDetails.emergencyContactDtls.length == 0
            ) {
              this.addFieldValue();
            }
            if (
              this.personalDetails.parentalLeaves == null ||
              this.personalDetails.parentalLeaves.length == 0
            ) {
              this.addParentalFieldValue();
            }
            if (this.personalDetails.Father.Deceased == true) {
              this.fatherDetReq = false;
            } else {
              this.fatherDetReq = true;
            }
            if (this.personalDetails.Mother.Deceased == true) {
              this.motherDetReq = false;
            } else {
              this.motherDetReq = true;
            }
            if (this.personalDetails.MaritalStatus == 1) {
              this.enableSpouseRequired = true;
            } else {
              this.enableSpouseRequired = false;
            }
            if (this.personalDetails.NoOfDependents > 0) {
              this.enableChildRequired = true;
            } else {
              this.enableChildRequired = false;
            }
          } else {
            this.addFieldValue();
            this.addParentalFieldValue();
          }
          if (
            this.personalDetails.parentalLeaves != null &&
            this.personalDetails.parentalLeaves.length > 0
          ) {
            for (
              var i = 0;
              i < this.personalDetails.parentalLeaves.length;
              i++
            ) {
              this.setToDate(
                this.personalDetails.parentalLeaves[i].FromDate,
                i
              );
              this.calculateDates(i);
            }
          }
          this.originalPersonalDetails = JSON.parse(
            JSON.stringify(this.personalDetails)
          );
          this.originalChildren = JSON.parse(
            JSON.stringify(this.Children.value)
          );
          this.EmitOutputValue();
        },
        (error) => (this.error = error)
      );
    }
  }

  isDisabled(date) {
    if (date != null) {
      var currentDate = new Date();
      var firstDayOfMonth = new Date(date);
      var minDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      return firstDayOfMonth > minDate ? false : true;
    }
  }

  setMinDate(date) {
    if (date != null) {
      var firstDayOfMonth = new Date(date);
      var currentDate = new Date();
      var currentMinDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      );
      return firstDayOfMonth.getTime() > currentMinDate.getTime()
        ? currentMinDate
        : firstDayOfMonth;
    } else {
      var firstDayOfMonth = new Date();
      return new Date(
        firstDayOfMonth.getFullYear(),
        firstDayOfMonth.getMonth() - 1,
        1
      );
    }
  }

  calculateAge(dob: Date, type: string, index = null) {
    var timeDiff = Math.abs(Date.now() - new Date(dob).getTime());
    this.Age = Math.floor(timeDiff / (1000 * 3600 * 24) / 365.25);
    if (type == "father") this.personalDetails.Father.Age = this.Age;
    else if (type == "mother") this.personalDetails.Mother.Age = this.Age;
    else if (type == "spouse") this.personalDetails.Spouse.Age = this.Age;
    else if (type == "children") {
      this.Children.value[index].Age = this.Age;
      this.Children.at(index).get("Age").setValue(this.Age);
    }
    if (this.personalDetails.Father.DOB) {
      this.disableIfFatherDOB = true;
    }
    if (this.personalDetails.Mother.DOB) {
      this.disableIfMotherDOB = true;
    }
    this.disableChild();
  }

  disableChild() {
    if (
      this.Children != null &&
      this.Children.value != null &&
      this.Children.length > 0
    ) {
      while (this.disableIfChildDOB.length < this.Children.length) {
        this.disableIfChildDOB.push(false); // Default value for new entries
      }
    }
    for (var i = 0; i < this.Children.value.length; i++) {
      if (this.Children.value[i].Age) {
        this.disableIfChildDOB[i] = true;
      }
    }
    if (!this.destroyed) this.cdr.detectChanges();
  }

  OnNoOfChildrenCount() {
    var dependents =
      this.personalDetails.NoOfDependents == ""
        ? -1
        : this.personalDetails.NoOfDependents;
    if (dependents > 0) {
      this.enableChildRequired = true;
      if (this.Children.value != null && this.Children.value.length != 0) {
        if (this.Children.value.length <= this.personalDetails.NoOfDependents) {
          var arr = this.Children.value;
          var count =
            this.personalDetails.NoOfDependents - this.Children.value.length;
          this.Children.clear();
          for (var i = 0; i < arr.length; i++) {
            this.createChildren(arr[i]);
          }
          for (var i = 0; i < count; i++) {
            this.createChildren();
          }
        } else if (
          this.Children.value.length > this.personalDetails.NoOfDependents
        ) {
          var arr = this.Children.value;
          var count =
            this.Children.value.length -
            (this.Children.value.length - this.personalDetails.NoOfDependents);
          this.Children.clear();
          for (var i = 0; i < count; i++) {
            this.createChildren(arr[i]);
          }
        }
      } else {
        for (var i = 0; i < this.personalDetails.NoOfDependents; i++) {
          this.createChildren();
        }
      }
    } else if (dependents == 0) {
      this.enableChildRequired = false;
      this.Children.clear();
    }
    if (!this.destroyed) this.cdr.detectChanges();
  }
  EmitOutputValue() {
    this.personalDetValue.emit(this.personalDetails);
    this.chilrenArray.emit(this.Children);
  }
}
